import ContentEventDetailsCard from "../content-event-details-card/ContentEventDetailsCard";

import { WarningSchema } from "@/schemas/warning-data-schema";

import "./style.scss";
import { useMemo } from "@wordpress/element";

type ContentEventsDetailsProps = {
	warningData: WarningSchema[];
	selectedPolygonId?: string;
	filter?: string;
};

export const ContentEventsDetails = ({
	warningData,
	selectedPolygonId,
	filter,
}: ContentEventsDetailsProps) => {
	console.log(warningData, selectedPolygonId, filter);

	const warningDataFiltered = useMemo(() => {
		if (!warningData?.length) return [];
		let result = warningData;

		if (selectedPolygonId) {
			result = result.filter((item) => item.geometry_id === selectedPolygonId);
		}

		if (filter) {
			const formattedFilter =
				filter.toLowerCase().split(" ").pop() ?? filter.toLowerCase();

			result = result.filter(
				(w) =>
					w.properties["event_en-US"]?.toLowerCase().includes(formattedFilter),
			);
		}

		return result.sort((a, b) => b.properties.value - a.properties.value);
	}, [warningData, selectedPolygonId, filter]);

	console.log(warningDataFiltered);

	return (
		<div className="content-events-details">
			{warningDataFiltered.map((item, idx) => (
				<ContentEventDetailsCard key={idx} data={item} />
			))}
		</div>
	);
};

export default ContentEventsDetails;
